import { toast } from "react-toastify";

import {
  fetchEditSubCategoryFailure,
  fetchEditSubCategorySuccess,
} from "./reducer";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

import { setSuccessMessage } from "../../toastMessage/action";

import { UPDATE_SUBCATEGORY } from "../../constants/constants";

export const editSubCategory =
  (
    payload,
    categoryId,
    pathArray,
    setLoading,
    callBack = () => {}
  ) =>
  async (dispatch) => {
    setLoading(true);

    await determineBaseUrlAndPerformApiCall(
      UPDATE_SUBCATEGORY(categoryId, ...pathArray),
      "PUT",
      payload
    )
      .then((response) => {
        if (response.error) {
          dispatch(
            fetchEditSubCategoryFailure(response.error.message)
          );

          toast.error(response.error.message);

          callBack();
        } else {
          dispatch(fetchEditSubCategorySuccess(response));

          dispatch(setSuccessMessage(true));

          toast.success("Sub Category Updated Successfully");

          callBack();
        }
      })
      .catch((error) => {
        dispatch(fetchEditSubCategoryFailure(error.message));
      })
      .finally(() => {
        setLoading(false);
      });
  };